import { DispatchWithoutAction, FC, useEffect } from 'react'

export const OnLoaded: FC<{ callback: DispatchWithoutAction }> = ({ callback }) => {
  useEffect(callback, [])

  return null
}
